<div class="forbidden-page bg-ambient min-h-screen flex flex-col items-center justify-center px-6 py-12">

  <div class="relative z-10 w-full max-w-lg text-center animate-in-up">

    <div class="forbidden-lock mx-auto mb-6" aria-hidden="true">
      <div class="lock-shackle"></div>
      <div class="lock-body">
        <img src="./icon.png" alt="" class="lock-logo" />
      </div>
    </div>

    <p class="text-xs font-semibold tracking-[0.2em] uppercase text-[var(--color-muted-foreground)] mb-3">
      Access restricted
    </p>

    <h1 class="font-display font-bold text-[var(--color-secondary)] text-7xl sm:text-8xl leading-none mb-2 forbidden-code">
      403
    </h1>

    <p class="text-sm text-[var(--color-muted-foreground)] mb-8 max-w-sm mx-auto">
      You're signed in, but your account doesn't have permission to open this area of Chipo.
    </p>

    <button
      type="button"
      (click)="goBack()"
      class="px-6 py-2.5 rounded-full text-sm font-semibold text-white
             bg-[var(--color-primary)] hover:bg-[var(--color-primary-dark)] transition-colors"
    >
      Return to dashboard
    </button>
  </div>
</div>
